export const LICENSES_KEY = ["licenses"];
